var map = {
	"./about-kangaroo-care.png": 15303,
	"./about-kc.jpg": 66776,
	"./child-development-clinic.png": 63155,
	"./childdevelopmetclinic.png 2.png": 48929,
	"./diet-for-expecting-moms.jpg": 48189,
	"./diet-plain.jpg": 75597,
	"./download-sec-2.jpg": 52920,
	"./download-sec-2.webp": 19062,
	"./download-sec-3.jpg": 64411,
	"./download-sec-3.webp": 54944,
	"./download-sec-4.jpg": 24334,
	"./download-sec-4.webp": 22962,
	"./download-sec-5.jpg": 62670,
	"./download-sec-5.webp": 7621,
	"./download-sec-6.jpg": 43393,
	"./download-sec-6.webp": 73073,
	"./download-sec-7.jpg": 99205,
	"./download-sec-7.webp": 20528,
	"./new-born-hearing-test.png": 37655,
	"./new-born-screening-test.png": 59917,
	"./newsletter.jpg": 61265,
	"./pain-relief.png": 19627,
	"./pain-relif-in-labour.jpg": 52856,
	"./pediatric-gastroenterology-clinic.png": 34821,
	"./pregnancy-yoga.jpg": 76560
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69840;